import { ReadNotificationDocument } from '../../graphql/graphql';

export const readNotification = ReadNotificationDocument;
